import { render, staticRenderFns } from "./SignupWaitingApprove.vue?vue&type=template&id=53b65a61&scoped=true&"
import script from "./SignupWaitingApprove.vue?vue&type=script&lang=ts&"
export * from "./SignupWaitingApprove.vue?vue&type=script&lang=ts&"
import style0 from "./SignupWaitingApprove.vue?vue&type=style&index=0&id=53b65a61&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b65a61",
  null
  
)

export default component.exports